

exports.__esModule = true;
exports.$xoGenericErrorPageComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _auth = require('xo-models/src/auth');

require('xo-ui-components/src/generic-error/directive');

require('xo-ui-components/src/message/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoGenericErrorPageComponent = exports.$xoGenericErrorPageComponent = _squid.$Component.extend('$xoGenericErrorPageComponent', {
    tag: 'xo-generic-error-page',
    template: _template2['default'],

    controller: ['$scope', function ($scope) {

        $scope.token = _angular.$rootScope.token;

        var models = {};

        (0, _squid.$populate)(models, {
            auth: _auth.$AuthModel.instance().retrieve()
        }).then(function () {

            $scope.logout = function () {

                if (window.xchild && _squid.$util.isIFrame()) {

                    window.xchild.hide();

                    var url = window.location.href.split('#')[0];

                    var xprops = _extends({}, window.xprops);

                    xprops.url = url;
                    xprops.payment = function () {
                        return models.auth.logout().then(function () {
                            return $scope.token;
                        });
                    };

                    return window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops);
                }

                models.auth.logoutAndRedirect('GENERIC_ERROR');
            };
        });

        var terminalKey = 'terminal-error-' + $scope.token,
            refreshKey = 'has-seen-error-' + $scope.token;

        if (!_squid.$util.sessionStorageEnabled() || !$scope.token || sessionStorage.getItem(terminalKey)) {
            return renderErrorPage();
        }

        // Google Pay - acount linking: show error page immediately without trying to redirect user to the login screen
        // as it's not allowed for the user to switch accounts in this flow
        if (_auth.$AuthModel.instance() && _auth.$AuthModel.instance().disallow_login_switch) {
            return renderErrorPage();
        }

        // is not a refresh
        if (!sessionStorage.getItem(refreshKey)) {
            sessionStorage.setItem(refreshKey, '1');
            return renderErrorPage();
        }

        // is a refresh
        else {
                _logger.$logger.info('checkout_fpti', {
                    user_refresh: 1
                });

                sessionStorage.removeItem(refreshKey);

                _uiRouter.$state.go('checkout.login')['catch'](function () {
                    return (
                        // don't try to do this again
                        sessionStorage.setItem(terminalKey, '1')
                    );
                });
            }

        function renderErrorPage() {
            // prevent render flicker
            $scope.shouldRender = true;
        }
    }]
});

angular.value("$xoGenericErrorPageComponent", $xoGenericErrorPageComponent);
_angular.$rootScope;

_squid.$Component;

_squid.$populate;

_squid.$util;

_uiRouter.$state;

_logger.$logger;

_auth.$AuthModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-generic-error/directive.js
// module id = ./pages/xo-generic-error/directive.js
// module chunks = 0